<template>
    <div>
        <b-row class="my-2">
            <b-col>
                <app-satisfaction-filters
                    @filter="onFilter"
                ></app-satisfaction-filters>
            </b-col>
        </b-row>
        <b-container v-if="dataLoaded">
            <b-row class="mt-3">
                <b-col cols="12" class="d-flex justify-content-center">
                    <app-gauge-chart
                        :title="generalTitle"
                        :width="400"
                        :height="150"
                        :indicator="general.indicator"
                        name="Satisfacción"
                    ></app-gauge-chart>
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-3">
                <b-col cols="12">
                    <!-- Indicadores por cliente -->
                    <app-column-chart
                        :title="byClientTitle"
                        :chart-data="byClient.data"
                        :show-data-table="false"
                        :width="columnChartWidth"
                    ></app-column-chart>
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-3">
                <b-col cols="12">
                    <!-- Indicadores por cliente -->
                    <app-column-chart
                        :title="byExecutiveTitle"
                        :chart-data="byExecutive.data"
                        :width="columnChartWidth"
                        :table-indicator="false"
                    ></app-column-chart>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col cols="12">
                    <!-- Indicadores por pregunta -->
                    <app-column-chart
                        :title="bySatisfactionPollQuestionTitle"
                        :chart-data="byPollQuestion.data"
                        :width="columnChartWidth"
                        :table-indicator="false"
                    ></app-column-chart>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import appSatisfactionFilters from './SatisfactionReportFilters'
import appGaugeChart from '../../Charts/GaugeChart'
import appColumnChart from '../../Charts/ColumnChart'
export default {
    components: {
        appSatisfactionFilters,
        appGaugeChart,
        appColumnChart,
    },
    data: () => ({
        dataMap,
        filters: '',
        dataLoaded: false,
        general: {
            indicator: '',
            avg: '',
            from: '',
            to: '',
        },
        byClient: {
            data: [],
            from: '',
            to: '',
        },
        byExecutive: {
            data: [],
            from: '',
            to: '',
        },
        byPollQuestion: {
            data: [],
            from: '',
            to: '',
        },
        columnChartWidth: 1000,
    }),
    computed: {
        generalTitle() {
            if (!this.general.from || !this.general.to)
                return 'Satisfacción General'

            return `Satisfacción general (${moment(this.general.from).format(
                'DD/MM/YYYY'
            )} - ${moment(this.general.to).format('DD/MM/YYYY')})`
        },
        byClientTitle() {
            if (!this.general.from || !this.general.to)
                return 'Satisfacción por cliente'

            return `Satisfacción por cliente (${moment(
                this.general.from
            ).format('DD/MM/YYYY')} - ${moment(this.general.to).format(
                'DD/MM/YYYY'
            )})`
        },
        byExecutiveTitle() {
            if (!this.general.from || !this.general.to)
                return 'Satisfacción por ejecutivo'

            return `Satisfacción por ejecutivo (${moment(
                this.general.from
            ).format('DD/MM/YYYY')} - ${moment(this.general.to).format(
                'DD/MM/YYYY'
            )})`
        },
        bySatisfactionPollQuestionTitle() {
            if (!this.general.from || !this.general.to)
                return 'Calificación general por pregunta'

            return `Calificación general por pregunta (${moment(
                this.general.from
            ).format('DD/MM/YYYY')} - ${moment(this.general.to).format(
                'DD/MM/YYYY'
            )})`
        },
    },
    methods: {
        onFilter(filters) {
            this.filters = filters
            this.loadGeneralSatisfaction()
            this.loadSatisfactionByClient()
            this.loadSatisfactionByExecutive()
            this.loadSatisfactionByPollQuestion()
        },
        async loadGeneralSatisfaction() {
            const { data } = await repo.get(
                'reporting/company/client-satisfaction',
                this.filters
            )
            this.general.indicator = parseFloat(
                (data.indicator * 100).toFixed(1)
            )
            this.general.avg = data.avg
            this.general.from = data.from
            this.general.to = data.to
        },
        async loadSatisfactionByClient() {
            const { data } = await repo.get(
                'reporting/company/client-satisfaction-by-client',
                this.filters
            )
            this.byClient.data = [['Cliente', 'Satisfacción']].concat(
                data.byClientData.map(item => [item.client_name, item.value])
            )
            this.byClient.from = data.from
            this.byClient.to = data.to
        },
        async loadSatisfactionByExecutive() {
            const { data } = await repo.get(
                'reporting/company/client-satisfaction-by-executive',
                this.filters
            )
            this.byExecutive.data = [['Cliente', 'Satisfacción']].concat(
                data.byExecutiveData.map(item => [
                    item.executive_name,
                    item.value,
                ])
            )
            this.byExecutive.from = data.from
            this.byExecutive.to = data.to
        },
        async loadSatisfactionByPollQuestion() {
            const { data } = await repo.get(
                'reporting/company/client-satisfaction-by-poll-question',
                this.filters
            )
            this.byPollQuestion.data = [['Pregunta', 'Calificación']].concat(
                data.bySatisfactionPollQuestionData.map(item => [
                    item.poll_name,
                    item.value,
                ])
            )
            this.byPollQuestion.from = data.from
            this.byPollQuestion.to = data.to
        },
    },
    created() {
        this.columnChartWidth = window.innerWidth * 0.8
    },
    mounted() {
        Promise.all([
            this.loadGeneralSatisfaction(),
            this.loadSatisfactionByClient(),
            this.loadSatisfactionByExecutive(),
            this.loadSatisfactionByPollQuestion()
        ]).then(() => (this.dataLoaded = true))
    },
}
const dataMap = {
    5: 100,
    4: 95,
    3: 85,
    2: 60,
    1: 25,
}
</script>
